<button
  type="button"
  class="search-backdrop"
  [class.search-backdrop--open]="searchService.isOpen()"
  [attr.aria-label]="'search.escape' | translate"
  (click)="searchService.close()"></button>

<div class="search-panel" [class.search-panel--open]="searchService.isOpen()" role="dialog" aria-modal="true">
  <form class="search-field" (submit)="$event.preventDefault(); onSubmit()">
    <app-icon class="search-glyph" name="search" [size]="18" />
    <input
      #searchInput
      type="text"
      class="search-input"
      [formControl]="query"
      [attr.placeholder]="'search.placeholder' | translate"
      [attr.aria-label]="'search.placeholder' | translate"
      [attr.aria-activedescendant]="activeResult() ? 'search-result-' + activeResult()!.globalIndex : null"
      role="combobox"
      aria-expanded="true"
      aria-controls="search-listbox"
      autocomplete="off" />
    <button type="button" class="search-esc" (click)="searchService.close()">
      {{ 'search.escape' | translate }}
    </button>
  </form>

  <div class="search-body" id="search-listbox" role="listbox">
    @if (trimmedQuery().length < minQueryLength) {
      <p class="search-hint">{{ 'search.minChars' | translate }}</p>
    } @else if (!hasResults()) {
      <p class="search-hint">{{ 'search.empty' | translate }}</p>
    } @else {
      @for (group of groups(); track group.labelKey) {
        @if (group.results.length > 0) {
          <div class="search-group-label">{{ group.labelKey | translate }}</div>
          @for (result of group.results; track result.sourceKey) {
            <button
              #resultButton
              type="button"
              role="option"
              [id]="'search-result-' + result.globalIndex"
              class="search-result"
              [class.search-result--shadow]="result.isShadow"
              [class.search-result--active]="result === activeResult()"
              [attr.aria-selected]="result === activeResult()"
              (mouseenter)="setActiveIndex(result.globalIndex)"
              (click)="openResult(result)">
              <img
                appImageFade
                class="search-result-thumb"
                [class.is-sprite]="result.isSprite"
                [class.is-avatar]="result.isAvatar"
                [attr.data-pogo-icon]="result.isSprite || result.hasColorThumbnail ? null : ''"
                [src]="result.thumbnailUrl"
                alt=""
                (error)="onImageError($event)" />
              <span class="search-result-title">
                {{ result.title }}
                @if (result.isShadow) {
                  <span class="search-result-shadow">
                    <img src="/icons/rocket.webp" alt="" />
                    {{ 'raidBosses.shadowChip' | translate }}
                  </span>
                }
                @if (result.subtitle) {
                  <span class="search-result-subtitle">&#183; {{ result.subtitle }}</span>
                }
              </span>
              @if (result.sourceLabelKey) {
                <span class="search-result-source">{{ result.sourceLabelKey | translate }}</span>
              }
            </button>
          }
        }
      }
    }
  </div>
</div>
